<template>
    <div class="vue-active-garage-block" v-click-outside="() => { this.open = false }" :class="{'no-garage': hasActiveGarage === false}">
        <template v-if="hasActiveGarage === true">
        <div class="dropdown show">

            <a class="dropdown-toggle" href="#" role="button" id="dropdown-garage" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="open" @click.prevent="handleClick" :class="{'is-active': open === true}">
                <span class="color-white d-block">{{ yourCarProf }}</span>
                {{ activeGarage.title }}
            </a>

            <div class="dropdown-menu" aria-labelledby="dropdown-garage" :class="{ 'show': open === true }">
                <div class="inner">
                    <h2 class="virtual-h4"><a :href="activeGarage.url">{{ activeGarage.title }}</a></h2>

                    <div class="info d-flex justify-content-between align-content-center">
                        <div class="contact">
                            <address>
                                <p>
                                    {{ activeGarage.streetNumber }}<br>
                                    {{ activeGarage.postalCodePlace }}<br>
                                </p>

                                <p>
                                    <template v-if="this.parsedPhonenumber">
                                        <a :href="`tel:${ parsedPhonenumber }`">{{ activeGarage.tel }}</a><br>
                                    </template>

                                    <a :href="'mailto:'+activeGarage.email">{{ sendAnEmail }}</a>
                                </p>
                            </address>
                        </div>

                        <div class="klantenvertellen" v-if="hasKlantenvertellen">
                            {{ activeGarage.klantenvertellen.averageScore }}
                        </div>
                    </div>

                        <template v-if="hasPlannerUrl && !hideAppointment">
                            <a :href="`${activeGarage.url}/afspraak-maken`" class="btn-arrow ml-0 mr-0">{{ makeAppointment }}</a>
                        </template>

                        <template v-if="!hasPlannerUrl && !hideAppointment">
                            <a :href="appointmentUrl" rel="noopener" oncontextmenu="return false;" class="btn-arrow mt-4 ml-0 mr-0 webform-dialog webform-dialog-narrow button">{{ makeAppointment }}</a>
                        </template>

                        <a :href="`${activeGarage.url}/prijs-berekenen`" class="btn-arrow-inverse mt-3">{{ calculatePrice }}</a>

                        <hr class="divider">

                        <a href="/vestigingen" class="cta-link">{{ selectDifferentLocation }}</a>


                </div>
            </div>
        </div>
    </template>
    </div>
</template>

<script>
import ActiveGarageMixin from "../mixins/ActiveGarageMixin";

export default {
    name: "ActiveGarageBlock",

    mixins: [ActiveGarageMixin],

    props: ['modalBus'],

    data() {
        return {
            open: false,
            yourCarProf: window.Drupal.t('Uw CarProf'),
            sendAnEmail: window.Drupal.t('Stuur een e-mail'),
            makeAppointment: window.Drupal.t('Afspraak maken'),
            calculatePrice: window.Drupal.t('Prijs berekenen'),
            selectDifferentLocation: window.Drupal.t('Selecteer een andere vestiging'),
        }
    },
    methods: {
        handleClick() {
            this.open = ! this.open;
        }
    }
}
</script>
